import React from 'react'
import { Handle, Position } from '@xyflow/react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { CustomTooltip } from '../../../../../components/TooltipCustomStyle';
import ErrorIcon from '@mui/icons-material/Error';
import TooltipStatusTitle from '../../../../../components/TooltipStatusTitle';
import CheckHandleNodeEvent from '../../../../../utils/CheckHandleNodeEvent';

const PrivacyNode = ({ data, selected, id, onNodeClick, highlighted }) => {

    const theme = useTheme();

    const handleNodeClick = (event) => {
        event.stopPropagation(); // ป้องกัน event bubbling
        if (onNodeClick) {
            onNodeClick(event, id);
        }
    };

    return (
        <div
            style={{
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '120px',
                backgroundColor: '#fff',
                border: selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.grey[500]}`,
                borderRadius: '5px',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                boxShadow: highlighted === "highlighted" ? `0 0 7px ${theme.palette.primary.main}` : 'none',
                opacity: highlighted === "unhighlighted" ? 0.6 : 1,
            }}
            onClick={handleNodeClick}
        >
            <Stack
                direction='row'
            >
                <div
                    style={{
                        width: '40px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        backgroundColor: '#1976d2',
                        padding: '5px 10px'
                    }}
                >
                    <LockIcon
                        color="white"
                        sx={{
                            width: 20,
                            height: 20,
                        }}
                    />
                </div>
                <div
                    style={{
                        flex: 1,
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'inline-block',
                        padding: '10px',
                    }}
                >
                    <Typography
                        variant='subtitle2'
                        fontSize={{
                            lg: 12,
                            md: 10,
                            sm: 10,
                            xs: 10
                        }}
                        sx={{
                            cursor: 'pointer',
                            textAlign: 'center',
                        }}
                    >
                        {data.general_properties.label}
                    </Typography>
                </div>
            </Stack>
            {data?.warning === true &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        // left: '80%',
                        right: data?.error === true ? '15px' : '2px',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1001,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Warning" listDetails={data?.warning_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.warning.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.warning.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            {/* {(data?.error === true && data?.warning === false) && */}
            {(data?.error === true || data?.error_text.length > 0) &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        // left: 'calc(80% + 13px)',
                        right: '2px',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            <Handle
                id="top-target"
                type="target"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected, "top-target")}
            />
            <Handle
                id="top-source"
                type="source"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected, "top-source")}
            />
            <Handle
                id="bottom-target"
                type="target"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected, "bottom-target")}
            />
            <Handle
                id="bottom-source"
                type="source"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected, "bottom-source")}
            />
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected, "left-target")}
            />
            <Handle
                id="left-source"
                type="source"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected, "left-source")}
            />
            <Handle
                id="right-target"
                type="target"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected, "right-target")}
            />
            <Handle
                id="right-source"
                type="source"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected, "right-source")}
            />
        </div>
    );
};

export default PrivacyNode;